import $ from "jquery";
import { t } from "~/hooks/useI18n";

/**
 * Interfaccia per la risposta delle chiamate API di invio form.
 */
export interface ApiResponse {
    success: boolean;
    responseText?: string;
    message?: string;
}

/**
 * Rappresenta lo stato condiviso della pagina Scheda Vendita.
 * Viene passato ai vari manager (AT, AD, Form) per evitare
 * duplicazione di stato e letture ripetute dal DOM.
 */
export class SchedaVenditaState {
    public auth: any = null;
    public userInfo: any = null;
    public isUserAuthenticated: boolean = false;

    public venditoreId: number = 0;
    public venditaId: number = 0;
    public lottoId: number = 0;
    public IdAstaTelematica: number = 0;

    public aggiudicato: boolean = false;
    public venduto: boolean = false;
    public isAtInCorso: boolean = false;
    public isBeneMobile: boolean = false;

    /**
     * Legge dal DOM i valori iniziali (hidden fields) e dallo strato auth le info utente.
     */
    public readFromDom(auth: any): void {
        this.auth = auth;
        this.userInfo = auth?.getCached ? auth.getCached("userInfo") : null;
        this.isUserAuthenticated = !!(this.userInfo && this.userInfo.anagraficaId > 0);

        this.venditoreId = parseInt($("#VenditoreId").val() as string) || 0;
        this.venditaId = parseInt($("#VenditaId").val() as string) || 0;
        this.lottoId = parseInt($("#LottoId").val() as string) || 0;
        this.IdAstaTelematica = parseInt($("#IdAstaTelematica").val() as string) || 0;

        const aggiudicato = ($("#Aggiudicato").val() as string) || "";
        const venduto = ($("#Venduto").val() as string) || "";
        this.aggiudicato = aggiudicato === "true";
        this.venduto = venduto === "true";

        this.isAtInCorso = ($("#IsATInCorso").val() as string)?.toLowerCase() === "true";
        this.isBeneMobile = ($("#IsBeneMobile").val() as string)?.toLowerCase() === "true";
    }
}

/**
 * Formatta data/ora in gg/mm/aaaa ore hh:mm.
 * Restituisce "-" per input non valido.
 */
export function formattaDataConOrario(dataOra: string | Date | null): string {
    if (!dataOra) {
        return "-";
    }
    const parsedDate = typeof dataOra === "string" ? new Date(dataOra) : dataOra;
    if (isNaN(parsedDate.getTime())) {
        return "-";
    }
    const giorno = parsedDate.getDate().toString().padStart(2, "0");
    const mese = (parsedDate.getMonth() + 1).toString().padStart(2, "0");
    const anno = parsedDate.getFullYear();
    const ore = parsedDate.getHours().toString().padStart(2, "0");
    const minuti = parsedDate.getMinutes().toString().padStart(2, "0");
    return `${giorno}/${mese}/${anno} ${t("common.ore")} ${ore}:${minuti}`;
}

/**
 * Countdown generico: aggiorna gli span countdown-* dentro `divCountdown`.
 */
export function startCountdownOn(dataOraFine: Date, divCountdown: HTMLDivElement,
    startCountdown: (d: number, h: number, m: number, s: number,
        onTick: (r: { days: number, hours: number, minutes: number, seconds: number }) => void,
        onEnd: () => void) => void): void {

    const now = new Date();
    const diffMs = dataOraFine.getTime() - now.getTime();
    if (diffMs <= 0) {
        divCountdown.remove();
        return;
    }
    const days = Math.floor(diffMs / (24 * 60 * 60 * 1000));
    const hours = Math.floor((diffMs % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
    const minutes = Math.floor((diffMs % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((diffMs % (60 * 1000)) / 1000);

    const $countdown = $(divCountdown);

    // Crea gli span del countdown se non sono già presenti nel markup
    if ($countdown.children().length === 0) {
        $countdown.html(`
            <span class="countdown-days">0</span>g:
            <span class="countdown-hours">0</span>h:
            <span class="countdown-minutes">0</span>m:
            <span class="countdown-seconds">0</span>s
        `);
    }

    startCountdown(days, hours, minutes, seconds,
        (remainingTime) => {
            $countdown.find(".countdown-days").text(remainingTime.days);
            $countdown.find(".countdown-hours").text(remainingTime.hours);
            $countdown.find(".countdown-minutes").text(remainingTime.minutes);
            $countdown.find(".countdown-seconds").text(remainingTime.seconds);
        },
        () => {
            divCountdown.remove();
        }
    );
}
